import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const getCampaignMetricsData = (body) => {
  return postRequest(API_URLS.CAMPAIGN_METRICS.BASE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const campaignMetricsService = {
  getCampaignMetricsData,
};
